import React from 'react';
import { DESK_EDIT_GROUP_COMPANY_SETTINGS } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import styles from './ClientTableRow.scss'

const deskEditGroupCompanySettingUrl = id => concatParamsToUrl(DESK_EDIT_GROUP_COMPANY_SETTINGS, { id: id });

const ClientTableRow = props => {
  const client = props.client
  return (
    <tr>
      <td>{client.id}</td>
      <td>{client.name}</td>
      <td>{client.isDisplayGroupCompanySetting == 2 ? 'disable' : 'enable'}</td>
      <td>
        {client.hasCompany ?
          <div className={styles.noteContainer}>
            <div>edit</div> 
            <p className={styles.note}>
              Group companies have been registered.<br />
              The setting cannot be changed.
            </p>
          </div> 
          :
          <a href={deskEditGroupCompanySettingUrl(client.id)}>edit</a>
        }
      </td>
    </tr>
  );
};

export default ClientTableRow;